theme.footerSection = (function(){
  function footer(){
    let accordion = true
    const footerWidgetAccordion = function () {
      accordion = false
      document.querySelectorAll(".footer__widget_toggle").forEach(function (item) {
        item.addEventListener('click', function () {
          const footerWidget = this.closest('.footer__widget'),
                footerWidgetInner = footerWidget.querySelector('.footer__widget_inner')
          if (!footerWidgetInner) return
          if(footerWidget.classList.contains('active')) {
            footerWidget.classList.remove('active')
            this.setAttribute('aria-expanded', 'false')
            slideUp(footerWidgetInner)
          } else {
            footerWidget.classList.add('active')
            this.setAttribute('aria-expanded', 'true')
            slideDown(footerWidgetInner)
            getSiblings(footerWidget.parentElement).forEach(function (item) {
              const footerWidget = item.querySelector('.footer__widget'),
                    footerWidgetInner = item.querySelector('.footer__widget_inner'),
                    footerWidgetToggle = item.querySelector('.footer__widget_toggle')
              if (!footerWidget || !footerWidgetInner) return
              footerWidget.classList.remove('active')
              if (footerWidgetToggle) footerWidgetToggle.setAttribute('aria-expanded', 'false')
              slideUp(footerWidgetInner)
            })

          }
        })
      })
    }
    if(accordion){
      footerWidgetAccordion();
    }
    window.addEventListener('resize', function () {
      document.querySelectorAll('.footer__widget').forEach(function (item) {
        if(window.innerWidth >= 768) {
          item.classList.remove('active')
          const footerWidgetInner = item.querySelector('.footer__widget_inner')
          const footerWidgetToggle = item.querySelector('.footer__widget_toggle')
          if (footerWidgetInner) footerWidgetInner.style.display = ''
          if (footerWidgetToggle) footerWidgetToggle.setAttribute('aria-expanded', 'false')
        }
      })
      if(accordion) {footerWidgetAccordion()}
    })
  }
  return footer;
})();
